module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.svg?c066c5448562b3ccaefb6408ce4b4ae1";